"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const react_1 = __importDefault(require("react"));
const login_styles_1 = require("./login.styles");
function Loader() {
    return (react_1.default.createElement(building_blocks_ui_common_1.Flex, null,
        react_1.default.createElement(login_styles_1.CircleLoader, null)));
}
exports.default = Loader;
//# sourceMappingURL=loader.js.map